import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import qs from 'qs';
import Header from '~/Components/Header/Header';
import WizardSteps from '~/Components/WizardSteps';
import FormularioSinal from '~/Components/Vendas/Sinal';
import FormularioFinanciamento from '~/Components/Vendas/Financiamento';
import Checkout from '~/Components/Vendas/Checkout';
import VendaGravada from '~/Components/Vendas/VendaGravada';
import VendaExcluida from '~/Components/Vendas/VendaExcluida';
import ResumoVenda from '~/Components/Vendas/Resumo';
import {
  carregarPropostaInicial,
  carregarPropostaAuxiliar,
  setProspectoVenda,
  setCondicoesEspeciais,
  setParcelasNaoConcomitantes,
  gravarVenda,
  autorizarVenda,
  excluirVenda,
  criarContraproposta,
} from '~/Store/Vendas/actions';
import {
  salvarSinal,
  adicionaFormaPgtoEntrada,
  removeFormaPgtoEntrada,
  atualizaFormaPgtoEntrada,
  removeTodasParcelasEntrada,
} from '~/Store/Vendas/Sinal/actions';

import {
  adicionaFormaPgtoEntradaImob,
  removeFormaPgtoEntradaImob,
  atualizaFormaPgtoEntradaImob,
  removeTodasParcelasEntradaImob,
} from '~/Store/Vendas/SinalMesa/actions';

import {
  adicionarParcelaFinanciamento,
  removerParcelaFinanciamento,
  atualizarParcelaFinanciamento,
  removerTodasParcelasFinanciamento,
  removerParcelasRegularesFinanciamento,
} from '~/Store/Vendas/Financiamento/actions';
import {
  setDataVenda,
  setCodigoPontoVenda,
} from '~/Store/Vendas/Checkout/actions';
import { dividirComissao } from '~/Store/Vendas/DivisaoComissao/actions';
import {
  selecionaTabelaPreco,
  selecionaAtivo,
  selecionaConstrutor,
} from '~/Store/Vendas/actions';
import ProspectoDetalhes from '~/Components/Prospectos/ProspectoDetalhes/ProspectoDetalhes';
import Loading from '~/Components/Loading';
import ErrorAlert from '~/Components/ErrorAlert';
import {
  listarMotivosParaAutorizacao,
  obterInformacoesAtivosSelecionados,
  calcularTotalVenda,
  calcularTotalEntrada,
  calcularTotalTitulosSinal,
  calcularTotalIncorporadora,
  calcularTotalImobiliaria,
  r2,
} from './helpers';
import { CHEQUE } from '~/constant';
import { TipoComissao } from '~/constant';
import { formatarMonetario } from '~/Utils/Helpers';
import * as api from '~/Services/Service';

const ETAPAS_VENDA = [
  'Prospecto',
  'Lotes e Entrada',
  'Financiamento',
  'Confirmação',
];

class Vendas extends Component {
  state = {
    etapaAtual: ETAPAS_VENDA[0],
    etapasCompletas: [],
    erro: '',
    autorizando: false,
    codigoProposta: null,
    infoFinanciamento: null,
    infoVendas: null,
    financiamentoOriginal: null,
    condicoesEspeciaisOriginal: null,
    valoresAlcada: null,
    codigoFamiliaAlcadaCarregada: null,
    // W-0981: enquanto `carregarPropostaAuxiliar` está hidratando o Redux,
    // `financiamentos` passa por estados intermediários. Tirar o snapshot de
    // "proposta como veio do servidor" nesse meio compara a proposta com ela
    // mesma pela metade. Ver `componentDidUpdate`.
    hidratandoPropostaAuxiliar: false,
  };

  componentDidMount() {
    const {
      carregarPropostaInicial,
      carregarPropostaAuxiliar,
      setProspectoVenda,
      match,
    } = this.props;
    const { prospecto, empreendimento } = match.params;
    const queryString = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });

    if (prospecto && empreendimento) {
      carregarPropostaInicial(empreendimento, prospecto);
      setProspectoVenda();
    } else if (queryString.codigoProposta) {
      this.setState({ hidratandoPropostaAuxiliar: true });
      carregarPropostaAuxiliar(queryString.codigoProposta).then(retorno => {
        setProspectoVenda();
        const { vendas } = this.props;
        // W-0981: o snapshot da proposta "como veio do servidor" é tirado aqui,
        // com o Redux já hidratado por completo, e não no primeiro
        // `componentDidUpdate` em que `financiamentos` fica não-vazio. Naquele
        // instante a fatia pode conter só `descontoSetclub` (o balão SetClube é
        // o primeiro despacho do laço de condicionantes), ainda sem
        // `parcelasFinanciamento` — e o Checkout então concluía que o valor do
        // financiamento havia mudado, exibindo contraproposta em vez de
        // efetivar.
        this.setState({
          autorizando: true,
          codigoProposta: queryString.codigoProposta,
          erro: retorno === true ? null : retorno,
          hidratandoPropostaAuxiliar: false,
          financiamentoOriginal:
            vendas &&
            vendas.financiamentos &&
            Object.keys(vendas.financiamentos).length > 0
              ? { ...vendas.financiamentos }
              : null,
          condicoesEspeciaisOriginal:
            vendas &&
            vendas.condicoesEspeciais &&
            Object.keys(vendas.condicoesEspeciais).length > 0
              ? { ...vendas.condicoesEspeciais }
              : null,
        });
      });
    } else {
      this.setState({ ...this.state, erro: 'Parâmetros inválidos.' });
    }
  }

  componentDidUpdate() {
    const { vendas } = this.props;

    const codigoFamiliaAtual = vendas && vendas.codigoFamilia;
    if (
      codigoFamiliaAtual &&
      this.state.codigoFamiliaAlcadaCarregada !== codigoFamiliaAtual
    ) {
      this.setState({ codigoFamiliaAlcadaCarregada: codigoFamiliaAtual });
      api
        .pegarValoresAlcadas(codigoFamiliaAtual)
        .then(valoresAlcada => this.setState({ valoresAlcada }))
        .catch(error =>
          this.setState({
            erro:
              error && error.message
                ? error.message
                : 'Não foi possível carregar as alçadas de carência.',
          })
        );
    }

    // W-0981: durante a hidratação da proposta auxiliar o snapshot é tirado no
    // `.then` do `componentDidMount`, com a fatia completa. Aqui ele serve só
    // ao fluxo de criação, em que o usuário monta o plano incrementalmente.
    if (this.state.hidratandoPropostaAuxiliar) return;

    if (
      vendas &&
      vendas.financiamentos &&
      Object.keys(vendas.financiamentos).length > 0 &&
      !this.state.financiamentoOriginal
    ) {
      this.setState({ financiamentoOriginal: { ...vendas.financiamentos } });
    }
    if (
      vendas &&
      vendas.condicoesEspeciais &&
      Object.keys(vendas.condicoesEspeciais).length > 0 &&
      !this.state.condicoesEspeciaisOriginal
    ) {
      this.setState({
        condicoesEspeciaisOriginal: { ...vendas.condicoesEspeciais },
      });
    }
  }

  alterarEtapa = (etapa = null) => {
    const indexAtual = etapa
      ? ETAPAS_VENDA.indexOf(etapa)
      : ETAPAS_VENDA.indexOf(this.state.etapaAtual) + 1;

    if (indexAtual < 0 || indexAtual >= ETAPAS_VENDA.length) return;

    const novasEtapasCompletas = ETAPAS_VENDA.slice(0, indexAtual + 1);

    const etapaAtual = ETAPAS_VENDA[indexAtual];
    this.setState({
      etapaAtual,
      etapasCompletas: novasEtapasCompletas,
    });
  };

  permiteAvancarEtapa = (
    etapa = null,
    ativosSelecionados,
    totalFaltanteEntrada,
    listaFormasDePagamento,
    financiamentos
  ) => {
    let permitir = false;
    let mensagem = '';
    switch (etapa) {
      case ETAPAS_VENDA[0]:
        const { prospecto } = this.props;
        permitir = prospecto && parseInt(prospecto.codigo_conta) > 0;
        if (!permitir)
          mensagem =
            prospecto && prospecto.codigo
              ? 'Para avançar, crie a pasta do prospecto.'
              : '';
        break;
      case ETAPAS_VENDA[1]:
        permitir = ativosSelecionados.length > 0 && totalFaltanteEntrada === 0;
        if (!permitir) {
          mensagem =
            'Para avançar, selecione os lotes e informe as parcelas de sinal.';
        }
        if (
          ativosSelecionados.length > 1 &&
          !listaFormasDePagamento.find(p => p.tipo_parcela === CHEQUE)
        ) {
          permitir = false;
          if (mensagem === '')
            mensagem =
              'Para avançar, informe um cheque como forma de pagamento de sinal';
          else
            mensagem += ' Informe um cheque como forma de pagamento de sinal';
        }
        if (
          this.props.vendas.empreendimento.tipo_recebimento_comissao ===
            TipoComissao.RetidaCorretor &&
          Number(this.props.totalTitulosSinal.toFixed(2)) >
            Number(this.props.totalEntrada.toFixed(2))
        ) {
          permitir = false;
          let erro =
            'O Sinal para imobiliária informado de ' +
            formatarMonetario(this.props.totalTitulosSinal) +
            ' é maior que o exigido de ' +
            formatarMonetario(this.props.totalEntrada) +
            '.';

          if (mensagem === '') {
            mensagem = erro;
          } else {
            mensagem += erro;
          }
        }

        if (
          this.props.vendas.empreendimento.tipo_recebimento_comissao ===
            TipoComissao.RetidaCorretor &&
          this.props.totalFaltanteEntradaIncorporadora != 0
        ) {
          permitir = false;
          mensagem += ' Informe as parcelas de sinal incorporadora.';
        }
        break;
      case ETAPAS_VENDA[2]:
        permitir = ativosSelecionados.every(
          codigo =>
            financiamentos[codigo] &&
            financiamentos[codigo].parcelasFinanciamento.filter(
              x => x.periodicidade_balao === null && !x.tipo_escadinha
            ).length > 0
        );
        if (!permitir)
          mensagem =
            'Para avançar, informe as condições de financiamento do(s) lote(s).';
        break;
      case ETAPAS_VENDA[3]:
        break;
      default:
        break;
    }
    return { permitir, mensagem };
  };

  render() {
    const {
      etapaAtual,
      etapasCompletas,
      autorizando,
      codigoProposta,
    } = this.state;

    const {
      totalVenda,
      totalEntrada,
      totalEntradaIncorporadora,
      selecionaTabelaPreco,
      selecionaConstrutor,
      vendas,
      selecionaAtivo,
      tabelasPorCodigo,
      ativosPorCodigo,
      salvarSinal,
      listaFormasDePagamento,
      listaFormasDePagamentoImob,
      totalFaltanteEntrada,
      totalFaltanteEntradaIncorporadora,
      totalTitulosSinal,
      totalTituloSinalIncorp,
      adicionaFormaPgtoEntrada,
      adicionaFormaPgtoEntradaImob,
      removeFormaPgtoEntrada,
      removeFormaPgtoEntradaImob,
      atualizaFormaPgtoEntrada,
      atualizaFormaPgtoEntradaImob,
      removeTodasParcelasEntrada,
      removeTodasParcelasEntradaImob,
      adicionarParcelaFinanciamento,
      removerTodasParcelasFinanciamento,
      removerParcelasRegularesFinanciamento,
      prospecto,
      gravarVenda,
      autorizarVenda,
      excluirVenda,
      criarContraproposta,
      corretores,
      dividirComissao,
      divisaoComissao,
      setDataVenda,
      setCodigoPontoVenda,
      cartoes,
    } = this.props;

    const {
      codigoProspecto,
      codigoFamilia,
      carregandoPropostaInicial,
      erroCarregamentoPropostaInicial,
      tabelaSelecionada,
      ativosSelecionados,
      empreendimento,
      isGravandoVenda,
      vendaGravada,
      erroGravacaoVenda,
      financiamentos,
      isExcluindoVenda,
      erroExclusaoVenda,
      vendaExcluida,
      checkout,
      vendaInterna,
      sinal,
      sinalMesa,
      travarVenda,
      condicoesEspeciais,
    } = vendas;

    const infoVendas = {
      financiamentos,
      sinal,
      sinalMesa,
    };

    const handleSetInfoVendas = infoFinanciamento => {
      this.setState(infoFinanciamento);
    };

    const listaMotivosAutorizacao = listarMotivosParaAutorizacao(
      vendas,
      tabelasPorCodigo,
      travarVenda,
      condicoesEspeciais,
      this.state.valoresAlcada
    );

    const erro = erroCarregamentoPropostaInicial || this.state.erro;

    return (
      <>
        <Header title="Vendas">
          {!vendaGravada && !vendaExcluida && (
            <WizardSteps
              steps={ETAPAS_VENDA}
              current={etapaAtual}
              complete={etapasCompletas}
              onClick={this.alterarEtapa}
            />
          )}
        </Header>

        <div className="container py-3">
          {carregandoPropostaInicial && (
            <Loading label="Carregando dados para venda..." />
          )}

          {erro && (
            <ErrorAlert>
              <p>{erro}</p>
            </ErrorAlert>
          )}

          {empreendimento && (
            <>
              {!!vendaGravada && <VendaGravada vendaGravada={vendaGravada} codigoProspecto={codigoProspecto} />}
              {vendaExcluida && (
                <VendaExcluida codigoProposta={codigoProposta} />
              )}
              {!vendaGravada && !vendaExcluida && (
                <div className="row">
                  <div className="col-md-4 order-md-2 mb-4">
                    <ResumoVenda
                      tabelaSelecionada={tabelasPorCodigo[tabelaSelecionada]}
                      empreendimento={empreendimento}
                      totalVenda={totalVenda}
                      totalTitulosSinal={totalTitulosSinal}
                      totalTituloSinalIncorp={totalTituloSinalIncorp}
                      ativosSelecionados={ativosSelecionados}
                      ativosPorCodigo={ativosPorCodigo}
                      ativosDaTabelaSelecionadaPorCodigo={
                        vendas.ativosDaTabelaSelecionadaPorCodigo
                      }
                      permissaoAvancar={this.permiteAvancarEtapa(
                        etapaAtual,
                        ativosSelecionados,
                        totalFaltanteEntrada,
                        empreendimento &&
                          empreendimento.tipo_recebimento_comissao ===
                            TipoComissao.RetidaCorretor
                          ? listaFormasDePagamentoImob
                          : listaFormasDePagamento,
                        financiamentos
                      )}
                      quandoAvancar={() => this.alterarEtapa()}
                      prospecto={prospecto}
                      etapaAtual={etapaAtual}
                      etapas={ETAPAS_VENDA}
                      listaMotivosAutorizacao={listaMotivosAutorizacao}
                      condicoesEspeciais={vendas.condicoesEspeciais}
                      financiamentoAnterior={this.state.financiamentoOriginal}
                      financiamentoAtual={vendas.financiamentos}
                      readonly={autorizando}
                      travarVenda={travarVenda}
                      carregandoPropostaInicial={carregandoPropostaInicial}
                    />
                  </div>

                  <div className="col-md-8 order-md-1">
                    {etapaAtual === ETAPAS_VENDA[0] && (
                      <ProspectoDetalhes
                        hiddenSearch
                        hiddenSelectEmpreendimento
                        prospectoID={codigoProspecto}
                        empreendimento={codigoFamilia}
                        readonly={autorizando}
                        liberarConsulta={true}
                      />
                    )}

                    {etapaAtual === ETAPAS_VENDA[1] && (
                      <FormularioSinal
                        empreendimento={empreendimento}
                        selecionaTabela={selecionaTabelaPreco}
                        selecionaConstrutor={selecionaConstrutor}
                        tabelaSelecionada={tabelasPorCodigo[tabelaSelecionada]}
                        selecionaAtivo={selecionaAtivo}
                        ativosSelecionados={ativosSelecionados}
                        tabelasPorCodigo={tabelasPorCodigo}
                        ativosDaTabelaSelecionadaPorCodigo={
                          vendas.ativosDaTabelaSelecionadaPorCodigo
                        }
                        totalEntrada={totalEntrada}
                        totalEntradaIncorporadora={totalEntradaIncorporadora}
                        totalFaltanteEntrada={totalFaltanteEntrada}
                        totalFaltanteEntradaIncorporadora={
                          totalFaltanteEntradaIncorporadora
                        }
                        totalTitulosSinal={totalTitulosSinal}
                        totalTituloSinalIncorp={totalTituloSinalIncorp}
                        salvarSinal={salvarSinal}
                        salvarDivisaoComissao={dividirComissao}
                        listaFormasDePagamento={listaFormasDePagamento}
                        listaFormasDePagamentoImob={listaFormasDePagamentoImob}
                        adicionaFormaPgtoEntrada={adicionaFormaPgtoEntrada}
                        adicionaFormaPgtoEntradaImob={
                          adicionaFormaPgtoEntradaImob
                        }
                        removeFormaPgtoEntrada={removeFormaPgtoEntrada}
                        removeFormaPgtoEntradaImob={removeFormaPgtoEntradaImob}
                        atualizaFormaPgtoEntrada={atualizaFormaPgtoEntrada}
                        atualizaFormaPgtoEntradaImob={
                          atualizaFormaPgtoEntradaImob
                        }
                        removeTodasParcelasEntrada={removeTodasParcelasEntrada}
                        removeTodasParcelasEntradaImob={
                          removeTodasParcelasEntradaImob
                        }
                        readonly={autorizando}
                        corretores={corretores}
                        divisaoComissao={divisaoComissao}
                        cartoes={cartoes}
                        dataVenda={checkout.dataVenda}
                        setDataVenda={setDataVenda}
                        codigoFamilia={codigoFamilia}
                        condicoesEspeciaisObj={vendas.condicoesEspeciais}
                        prospecto={prospecto}
                      />
                    )}

                    {etapaAtual === ETAPAS_VENDA[2] && (
                      <FormularioFinanciamento
                        ativosPorCodigo={ativosPorCodigo}
                        empreendimento={empreendimento}
                        prospecto={prospecto}
                        tabelaSelecionada={tabelasPorCodigo[tabelaSelecionada]}
                        ativosSelecionados={ativosSelecionados}
                        tabelasPorCodigo={tabelasPorCodigo}
                        ativosDaTabelaSelecionadaPorCodigo={
                          vendas.ativosDaTabelaSelecionadaPorCodigo
                        }
                        listaFormasDePagamento={listaFormasDePagamento}
                        listaFormasDePagamentoImob={listaFormasDePagamentoImob}
                        adicionarParcelaFinanciamento={
                          adicionarParcelaFinanciamento
                        }
                        financiamentos={financiamentos}
                        readonly={autorizando}
                        totalTitulosSinal={totalTitulosSinal}
                        totalTitulosSinalIncorp={totalTituloSinalIncorp}
                        removerTodasParcelasFinanciamento={
                          removerTodasParcelasFinanciamento
                        }
                        removerParcelasRegularesFinanciamento={
                          removerParcelasRegularesFinanciamento
                        }
                        taxaParcelaIntermediaria={
                          tabelasPorCodigo[tabelaSelecionada]
                            .taxa_parcela_intermediaria
                        }
                        taxaTabela={
                          tabelasPorCodigo[tabelaSelecionada].juros_mensal
                        }
                        dataVenda={checkout.dataVenda}
                        setInfoVendas={handleSetInfoVendas}
                        condicoesEspeciais={vendas.condicoesEspeciais}
                        financiamentoAnterior={this.state.financiamentoOriginal}
                        financiamentoAtual={vendas.financiamentos}
                        setParcelasNaoConcomitantes={
                          setParcelasNaoConcomitantes
                        }
                      />
                    )}

                    {etapaAtual === ETAPAS_VENDA[3] && (
                      <Checkout
                        ativosDaTabelaSelecionadaPorCodigo={
                          vendas.ativosDaTabelaSelecionadaPorCodigo
                        }
                        erroGravacaoVenda={erroGravacaoVenda}
                        readonly={autorizando}
                        listaMotivosAutorizacao={listaMotivosAutorizacao}
                        totalTitulosSinal={totalTitulosSinal}
                        codigoContaCliente={prospecto.codigo_conta}
                        gravarVenda={gravarVenda}
                        isGravandoVenda={isGravandoVenda}
                        autorizando={autorizando}
                        autorizarVenda={autorizarVenda}
                        isExcluindoVenda={isExcluindoVenda}
                        erroExclusaoVenda={erroExclusaoVenda}
                        excluirVenda={() => excluirVenda(codigoProposta)}
                        criarContraproposta={() =>
                          criarContraproposta(
                            codigoProposta,
                            vendas.condicoesEspeciais
                          )
                        }
                        dataVenda={checkout.dataVenda}
                        codigoPontoVenda={checkout.codigoPontoVenda}
                        setCodigoPontoVenda={setCodigoPontoVenda}
                        codigoProposta={codigoProposta}
                        vendaInterna={vendaInterna}
                        infoVendas={infoVendas}
                        ativosPorCodigo={ativosPorCodigo}
                        travarVenda={travarVenda}
                        condicoesEspeciais={vendas.condicoesEspeciais}
                        codigoFamilia={codigoFamilia}
                        financiamentoAnterior={this.state.financiamentoOriginal}
                        financiamentoAtual={vendas.financiamentos}
                        condicoesEspeciaisAnterior={
                          this.state.condicoesEspeciaisOriginal
                        }
                        empreendimento={empreendimento}
                      />
                    )}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = state => {
  let ativos = [];
  let totalVenda = 0;
  let totalEntrada = 0;
  let totalEntradaIncorporadora = 0;
  let totalFaltanteEntrada = totalEntrada;
  let totalFaltanteEntradaIncorporadora = totalEntradaIncorporadora;
  let totalTitulosSinal = 0;
  let totalTituloSinalIncorp = 0;

  let { empreendimento } = state.vendas;

  if (empreendimento && empreendimento.ativos) {
    ativos = obterInformacoesAtivosSelecionados(state.vendas);
    totalVenda = calcularTotalVenda(ativos);
    totalEntrada =
      empreendimento.tipo_recebimento_comissao === TipoComissao.RetidaCorretor
        ? calcularTotalImobiliaria(ativos)
        : calcularTotalEntrada(ativos);

    if (
      empreendimento.tipo_recebimento_comissao === TipoComissao.RetidaCorretor
    ) {
      totalEntradaIncorporadora = calcularTotalIncorporadora(ativos);

      totalTitulosSinal = calcularTotalTitulosSinal(
        state.vendas.sinalMesa.listaFormasDePagamentoImob
      );
      totalTituloSinalIncorp = calcularTotalTitulosSinal(
        state.vendas.sinal.listaFormasDePagamento
      );

      totalFaltanteEntradaIncorporadora = r2(
        totalEntradaIncorporadora - totalTituloSinalIncorp
      );
      if (totalFaltanteEntradaIncorporadora < 0)
        totalFaltanteEntradaIncorporadora = 0;
    } else {
      totalTitulosSinal = calcularTotalTitulosSinal(
        state.vendas.sinal.listaFormasDePagamento
      );
    }

    totalFaltanteEntrada = r2(totalEntrada - totalTitulosSinal);
    if (totalFaltanteEntrada < 0) totalFaltanteEntrada = 0;
  }

  return {
    totalVenda,
    totalEntrada,
    totalEntradaIncorporadora,
    prospecto: state.vendas.prospecto,
    sinal: state.vendas.sinal,
    sinalMesa: state.vendas.sinalMesa,
    tabelasPorCodigo: state.vendas.tabelasPorCodigo,
    ativosPorCodigo: state.vendas.ativosPorCodigo,
    financiamentos: state.vendas.financiamentos,
    vendas: state.vendas,
    listaFormasDePagamento: state.vendas.sinal.listaFormasDePagamento,
    listaFormasDePagamentoImob:
      state.vendas.sinalMesa.listaFormasDePagamentoImob,
    totalFaltanteEntrada,
    totalFaltanteEntradaIncorporadora,
    totalTitulosSinal,
    totalTituloSinalIncorp,
    corretores: state.corretor.listaCorretores,
    divisaoComissao: state.vendas.divisaoComissao,
    cartoes: state.vendas.cartoes,
    condicoesEspeciais: state.vendas.condicoesEspeciais,
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      adicionaFormaPgtoEntrada,
      adicionaFormaPgtoEntradaImob,
      removeFormaPgtoEntrada,
      removeFormaPgtoEntradaImob,
      atualizaFormaPgtoEntrada,
      atualizaFormaPgtoEntradaImob,
      removeTodasParcelasEntrada,
      removeTodasParcelasEntradaImob,
      selecionaTabelaPreco,
      selecionaConstrutor,
      setProspectoVenda,
      setCondicoesEspeciais,
      setParcelasNaoConcomitantes,
      carregarPropostaInicial,
      carregarPropostaAuxiliar,
      selecionaAtivo,
      salvarSinal,
      adicionarParcelaFinanciamento,
      removerParcelaFinanciamento,
      removerTodasParcelasFinanciamento,
      removerParcelasRegularesFinanciamento,
      atualizarParcelaFinanciamento,
      gravarVenda,
      autorizarVenda,
      dividirComissao,
      excluirVenda,
      criarContraproposta,
      setDataVenda,
      setCodigoPontoVenda,
    },
    dispatch
  );

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Vendas));
